import { addUserGroupV2 } from "../../basic/path"
import RequestModel from "../../basic/requestConfig";

export default {
    loadPopulationSize(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                method: 'post',
                url: addUserGroupV2.loadPopulationSize,
                data: query.data ? query.data : {},
                params: query.params ? query.params : {},
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
            }),
            request = requestModel.tokenConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
   
    
    addUserGroup(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: addUserGroupV2.addUserGroup,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
            }),
            request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },addCombineUserGroup(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'post',
                    url: addUserGroupV2.addCombineUserGroup,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    }
            }),
            request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },randomNumber(vue, query) {
        return new Promise((resolve, reject) => {
            let requestModel = new RequestModel({
                    method: 'get',
                    url: addUserGroupV2.randomNumber,
                    data: query.data ? query.data : {},
                    params: query.params ? query.params : {},

            }),
            request = requestModel.defaultConfig();
            vue.axios(request).then(function (result) {
                resolve(result);
            })
        });
    },
}